// Currency utilities & formatter — used everywhere prices are shown
const SYMBOLS = {
  SDG: "ج.س",
  USD: "$",
  SAR: "﷼",
  AED: "د.إ",
  EGP: "ج.م",
  EUR: "€",
  GBP: "£",
};

// Map browser locale region → currency
const REGION_TO_CURRENCY = {
  SD: "SDG", US: "USD", SA: "SAR", AE: "AED", EG: "EGP",
  GB: "GBP", DE: "EUR", FR: "EUR", IT: "EUR", ES: "EUR",
};

export function detectCurrency() {
  try {
    const stored = localStorage.getItem("so_currency");
    if (stored) return stored;
    const locale = (navigator.language || "en-SD").toUpperCase();
    const region = locale.split("-")[1] || "SD";
    return REGION_TO_CURRENCY[region] || "SDG";
  } catch {
    return "SDG";
  }
}

export function formatPrice(amount, currency = "SDG", lang = "en") {
  const sym = SYMBOLS[currency] || currency;
  const num = Number(amount || 0);
  const formatted = num.toLocaleString(lang === "ar" ? "ar-SD" : "en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  // Symbol placement: SDG/SAR/AED/EGP after; USD/EUR/GBP before
  if (["SDG", "SAR", "AED", "EGP"].includes(currency)) return `${formatted} ${sym}`;
  return `${sym}${formatted}`;
}

export { SYMBOLS };
